import React from 'react';
import { Markup } from 'interweave';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import Edit from '@material-ui/icons/Edit';

import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import ContentCard from 'components/ContentCard/ContentCard';
import SFWOverlay from 'components/SFWOverlay/SFWOverlay';
import routeDefinitions from 'enum/routeDefinitions';
import { shouldShowEditButton } from 'utils/helpers';

import styles from './CustomHTML.css';


const CustomHTML = () => {
  const { profileInfo, profileName } = ProfileStore;
  const { user } = UserStore;
  const route = routeDefinitions.get(routeDefinitions.profileSettingsRoutes.html, { username: user.username });
  const containsImage = profileInfo.htmlBio && profileInfo.htmlBio.includes('<img');

  return (
    <ContentCard>
      <div className={styles.container}>
        {user.sfw && containsImage && <SFWOverlay />}
        {shouldShowEditButton(user, profileName) && (
          <Link className={styles.editIcon} to={route}>
            <Edit />
          </Link>
        )}
        <Markup allowAttributes={['size']} allowElements={['font']} content={profileInfo.htmlBio} />
      </div>
    </ContentCard>
  );
};

export default observer(CustomHTML);
